/* Shared only by the new catalog sections; legacy MTO files remain untouched. */
(() => {
  'use strict';
  if (customElements.get('catalog-assets')) return;

  class CatalogAssets extends HTMLElement {
    connectedCallback() {
      const source = this.dataset.cardScript;
      if (!source) return;
      const url = new URL(source, document.baseURI).href;
      if ([...document.scripts].some((script) => script.src === url)) return;
      const script = document.createElement('script');
      script.src = url;
      script.defer = true;
      document.head.append(script);
    }
  }
  customElements.define('catalog-assets', CatalogAssets);
})();
